import './login.scss';
import { monitorAuthState } from './modules/firebase/Auth';
import { initTheme } from './modules/ui/theme';

const setViewportHeight = (): void => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
};

setViewportHeight();
window.addEventListener('resize', setViewportHeight);
initTheme();
void monitorAuthState();
